import { motion } from "framer-motion";
import { WhatsappLogo } from "@phosphor-icons/react";
import { whatsappLink } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export default function WhatsAppButton() {
  const { t } = useLang();
  return (
    <motion.a
      data-testid="whatsapp-float-btn"
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, rotate: -30 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ type: "spring", stiffness: 260, damping: 18, delay: 1 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="fixed bottom-6 right-6 z-[90] flex items-center gap-2 rounded-full pl-4 pr-5 py-3 text-white font-bold shadow-soft-lg"
      style={{ background: "#25D366" }}
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <WhatsappLogo weight="fill" size={26} className="relative" />
      <span className="relative text-sm hidden sm:block">{t("whatsapp")}</span>
    </motion.a>
  );
}
